import { render, staticRenderFns } from "./LegoParam.vue?vue&type=template&id=45294074&scoped=true&"
import script from "./LegoParam.vue?vue&type=script&lang=ts&"
export * from "./LegoParam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45294074",
  null
  
)

export default component.exports